
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
export default Vue.extend({
	props: {
		isPurchase: Boolean,
	},
	computed: {
		title():TranslateResult{
			if (this.isPurchase){
				return this.$ct("create-purchase-ubl-archive");
			}
			return this.$ct("create-ubl-archive");
		}
	},
	methods: {
		close(){
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
